
import Vue from 'vue';
import BaseIcon from '~/components/BaseIcon.vue';
import BaseSliderIndicator from '~/components/BaseSliderIndicator.vue';

export default Vue.extend({
  name: 'SliderTextImage',
  components: {
    BaseIcon,
    BaseSliderIndicator,
  },
  props: {
    slides: {
      type: Array,
    },
    overlay: {
      type: [Array, Object],
    },
    headline: {
      type: [Array, Object],
    },
    button: {
      type: [Array, Object],
    },
    text: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      selectedEntryIndex: 0,
      images: [],
      overlayTopPosition: '50%',
    };
  },
  mounted() {
    this.$refs.historyContainer.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.updateSliderIndicatorOffset);
    window.addEventListener('load', this.updateSliderIndicatorOffset);
    this.positionOverlay(this.selectedEntryIndex);
  },
  beforeDestroy() {
    this.$refs.historyContainer.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateSliderIndicatorOffset);
    window.removeEventListener('load', this.updateSliderIndicatorOffset);
  },
  methods: {
    changeEntry(index) {
      if (index < 0)  {
        index = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        index = 0;
      }

      const entryContainer = this.$refs.historyContainer;

      const scrollWidth = entryContainer.scrollWidth;
      const entryWidth = scrollWidth / this.slides.length;

      entryContainer.scrollTo({ left: index * entryWidth, behavior: 'smooth'});

      this.positionOverlay(index);
    },
    onScroll() {
      const scrollIndex = this.getScrollIndex();

      if (scrollIndex === this.selectedEntryIndex) {
        return;
      }

      this.selectedEntryIndex = scrollIndex;
      this.$refs.sliderIndicator.selectIndex(scrollIndex);

      const sliderWrapper = this.$refs.sliderWrapper;
      const wrapperScrollWidth = sliderWrapper.scrollWidth;
      if (wrapperScrollWidth <= sliderWrapper.clientWidth) {
        return;
      }

      const tabEntryWidth = wrapperScrollWidth / this.slides.length;
      sliderWrapper.scrollTo({ left: scrollIndex * tabEntryWidth, behavior: 'smooth'});
    },
    updateSliderIndicatorOffset() {
      const scrollIndex = this.getScrollIndex();
      this.positionOverlay(this.selectedEntryIndex);
    },
    getScrollIndex() {
      const entryContainer = this.$refs.historyContainer;

      const scrollLeft = entryContainer.scrollLeft;
      const scrollWidth = entryContainer.scrollWidth;

      const entryWidth = scrollWidth / this.slides.length;

      return Math.round(scrollLeft / entryWidth);
    },
    positionOverlay(index) {
      let slideContainer = this.$refs.historyContainer;
      let slides = slideContainer.querySelectorAll('.slide-image-entry');

      if (slides.length <= 0) {
        return;
      }

      let currentSlide = slides[index];

      if (!currentSlide) {
        return;
      }

      let overlay = this.$refs.overlay;
      let overlayHeight = overlay.querySelector('img')?.height || null;
      let slideHeight = currentSlide.querySelector('img')?.height || null;

      if (
        !currentSlide
        || !currentSlide.querySelector('img') || !overlay
        || !overlayHeight
        || !slideHeight
      ) {
        return;
      }

      this.overlayTopPosition = `${(slideHeight * 0.95)-(overlayHeight/2)}px`;
    },
  },
});
